import type { ComponentType } from 'react';
import { lazy } from 'react'

/**
 * A wrapper for React.lazy that attempts to reload the page once if a chunk fails to load.
 * This is useful for handling "Failed to fetch dynamically imported module" errors
 * which occur when the client has a stale index.html pointing to deleted asset hashes.
 */
export const lazyWithRetry = (componentImport: () => Promise<{ default: ComponentType<any> }>) =>
  lazy(async () => {
    const pageHasBeenForceRefreshed = JSON.parse(
      window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false'
    )

    try {
      const component = await componentImport()

      window.sessionStorage.setItem('page-has-been-force-refreshed', 'false')

      return component
    } catch (error) {
      if (!pageHasBeenForceRefreshed) {
        // Chunk load failed, force a refresh once
        window.sessionStorage.setItem('page-has-been-force-refreshed', 'true')

        return window.location.reload() as any
      }

      // If we already refreshed and it still fails, throw the error
      throw error
    }
  })
